module.exports = __webpack_public_path__ + "static/media/mongoose.1c3eba17.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/mongoose.png
// module id = 167
// module chunks = 0